export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const SIDEBAR_CLOSE = "SIDEBAR_CLOSE";
export const GET_CARDS_BEGIN = "GET_CARDS_BEGIN";
export const GET_CARDS_SUCCESS = "GET_CARDS_SUCCESS";
export const GET_CARDS_ERROR = "GET_CARDS_ERROR";
export const GET_SINGLE_CARD_BEGIN = "GET_SINGLE_CARD_BEGIN";
export const GET_SINGLE_CARD_SUCCESS = "GET_SINGLE_CARD_SUCCESS";
export const GET_SINGLE_CARD_ERROR = "GET_SINGLE_CARD_ERROR";
export const LOAD_CARDS = "LOAD_CARDS";
export const SET_GRIDVIEW = "SET_GRIDVIEW";
export const SET_LISTVIEW = "SET_LISTVIEW";
export const UPDATE_SORT = "UPDATE_SORT";
export const SORT_CARDS = "SORT_CARDS";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const FILTER_CARDS = "FILTER_CARDS";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const TOGGLE_CART_ITEM_AMOUNT = "TOGGLE_CART_ITEM_AMOUNT";
export const CLEAR_CART = "CLEAR_CART";
export const COUNT_CART_TOTALS = "COUNT_CART_TOTALS";
